/**
 * @module jss
 *
 * Create and manipulate CSS in JS.
 *
 * @see https://mui.com/styles/basics/
 */
import combineStyles from 'classnames';
import { useTheme, lighten, darken } from '@mui/material/styles';
import { makeStyles, withStyles } from '@mui/styles';

export const jss = {
  combineStyles,
  makeStyles,
  withStyles,
  useTheme,
  lighten,
  darken,
};
